import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d97334b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "IDETabs tablist" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-xmark" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]

import { ref, withDefaults, watch } from 'vue';
import * as FileIcon from '@/components/FileIcon.vue';


export interface PropsOptions {
	tabsList: Array<Tab>,
}



export interface Tab {
	filename: string,
	name: string,
	active: boolean,
	isLectorActiveEditor: boolean,
	openByLector: boolean,
}

export const EmitsOptions = {
	'onSelectTab' : (tab: Tab) => {return true;},
	'onCloseTab' : (tab: Tab) => {return true;},
}

export default /*#__PURE__*/_defineComponent({
  __name: 'IDETabs',
  props: {
    tabsList: { default() {
		return [];
	} }
  },
  emits: EmitsOptions,
  setup(__props: any, { emit }) {

const props = __props as { tabsList: Array<Tab> }





function onSelectTab(tab:Tab) {
	emit('onSelectTab', tab);
}

function onCloseTab(tab:Tab) {
	emit('onCloseTab', tab);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabsList, (tab) => {
      return (_openBlock(), _createElementBlock("div", {
        onClick: ($event: any) => (onSelectTab(tab)),
        key: tab.filename,
        class: _normalizeClass(["tab", {active: tab.active}])
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(FileIcon.default, {
            filename: tab.name
          }, null, 8, ["filename"])
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(tab.name), 1),
        (tab.isLectorActiveEditor)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass({isLectorActiveEditor: tab.isLectorActiveEditor && !tab.active})
            }, null, 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onClick: _withModifiers(($event: any) => (onCloseTab(tab)), ["stop"]),
          class: _normalizeClass(["close", {hidden: tab.openByLector}])
        }, _hoisted_7, 10, _hoisted_5)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})